import { resolveUrl } from "./urlResolver";

export const HOMEPAGE = resolveUrl("/").replace(/\/$/, "");
export const REGISTER_PAGE = resolveUrl("/registered/user");
export const CUSTOMER_REGISTER_PAGE = resolveUrl("/become-schaeffler-customer");
export const STC_PAGE = resolveUrl("/stc");
export const WISHLIST_PAGE = resolveUrl("/wishlist");
export const PRODUCT_COMPARISON_PAGE = resolveUrl("/product-comparison");
export const SAVED_CONFIGS_PAGE = resolveUrl("/saved-configs");
export const COOKIE_POLICY_PAGE = resolveUrl("/cookie_policy");
export const STORE_FINDER = resolveUrl("/store-finder");
export const FREE_CAPACITY_COCKPIT = resolveUrl("/freecapacitycockpit");
export const SELECTION_ASSISTANT = resolveUrl("/selectionassistant?sort=name-asc");
export const ACCOUNT_SELECTION_URL = resolveUrl("/selectaccount");
export const TERMS_OF_USE_PAGE = resolveUrl("/terms-of-use");
export const PRIVACY_PAGE = resolveUrl("/privacy");
export const MY_ACCOUNT_PAGE = resolveUrl("/my-account");
export const MY_ACCOUNT_ORDER_QUOTES_SETTINGS_PAGE = resolveUrl("/my-account/orderAndQuoteSettings");
export const MY_ACCOUNT_SHIPPING_ADDRESSES_PAGE = resolveUrl("/my-account/shippingAddresses");
export const MY_ACCOUNT_ACCOUNT_SETTINGS_PAGE = resolveUrl("/my-account/accountSettings");
export const CART_PAGE = resolveUrl("/cart");
export const CHECKOUT_PAGE = resolveUrl("/checkout/multi/summary/view");
export const SEARCH_PAGE = resolveUrl("/search/searchpage");
export const SEARCHPAGE_BY_DESIGNATION = resolveUrl("/search/searchpage/designation");
export const ACTIVE_QUOTE_PAGE = resolveUrl("/quote");
export const QUOTE_CONFIRMATION_PAGE = resolveUrl("/quote/confirm");
export const LINEAR_CONFIGURATOR_URL = resolveUrl("/linear-configurator");
export const CARRIAGES_CONFIGURATOR_URL = resolveUrl("/carriages-configurator");
export const RAILS_CONFIGURATOR_URL = resolveUrl("/rails-configurator");
export const METRIC_SHAFT_CONFIGURATOR_URL = resolveUrl("/metric-shaft-configurator");
export const INCH_SHAFT_CONFIGURATOR_URL = resolveUrl("/inch-shaft-configurator");

export const LINEAR_CONFIGURATION_REQUEST_QUOTE_CONFIRMATION_PAGE_URL = resolveUrl(
  "/requestLinearConfigurationQuote/confirmation",
);
export const LINEAR_CONFIGURATION_DISCLAIMER = resolveUrl("/cad-info");
export const AB_MONITOR_PAGE = resolveUrl("/abmonitor");
export const ORDER_HISTORY_PAGE = resolveUrl("/my-account/orderHistory");
export const QUOTE_HISTORY_PAGE = resolveUrl("/my-account/quotes/search");
export const CONTRACT_OVERVIEW_PAGE = resolveUrl("/my-account/contractOverview");
export const NEW_CONTRACT_PAGE = resolveUrl("/my-account/new-contract");
export const MANAGE_USERS_PAGE = resolveUrl("/my-company/organization-management/manage-users");

export const OPTIME_SOLUTIONS_URL = "https://www.schaeffler.de/optime";
export const URL_CONTACT_US = resolveUrl(window.SCHA.urls.contactUs);
export const URL_GENERAL_CONDITIONS = resolveUrl(window.SCHA.urls.generalConditions);
export const URL_OPTIME_TERMS = resolveUrl(window.SCHA.urls.optimeTermsConditions);
export const URL_GENERAL_TERMS = resolveUrl(window.SCHA.urls.generalConditions);
export const URL_PREFERRED_PRODUCTS = resolveUrl(window.SCHA.urls.preferredProductsUrl);
export const URL_RECONDITIONABLE = resolveUrl("/remanufacturing");
export const URL_MMD = resolveUrl(window.SCHA.urls.mmdUrl);

export const URL_BULK_TEMPLATE = window.SCHA.urls.templateUrl;
export const URL_BULK_TEMPLATE_XLSX = window.SCHA.urls.templateXlsxUrl;
export const SHARE_LINEAR_CONFIGURATIONS_CONFIRMATION_PAGE_URL = resolveUrl(
  "/sendLinearConfigurationsViaEmail/confirmation",
);
export const HOUSING_SELECTION_ASSISTANT_URL = resolveUrl("/housingselectionassistant");
export const NOTIFICATIONS_PAGE_RAW = "/notifications";
export const NOTIFICATIONS_PAGE = resolveUrl(NOTIFICATIONS_PAGE_RAW);
export const NOTIFICATIONS_SETTINGS_PAGE = resolveUrl("/notifications/settings");
export const SCAN_DMC_PAGE = resolveUrl("/scandmc");
export const SALES_CAMPAIGN_PAGE = resolveUrl("/campaign");
export const HEATER_SELECTION_ASSISTANT_URL = resolveUrl("/heating-manager");
export const GEARBOX_SELECTION_ASSISTANT_URL = resolveUrl("/gearboxselectionassistant");
export const LUBRICATION_SELECTION_ASSISTANT_URL = resolveUrl("/lubrication-selection-assistant");
export const LMS_TRAINING_OVERVIEW_URL = resolveUrl("/training-campus");

export const CART_STEP_2 = resolveUrl("/cart/store-finder");
export const CART_STEP_3 = resolveUrl("/cart/request");
